module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding": "0px"
    }
  }, [(_vm.disable === false) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "title": '<h5>Cadastrar novo participante</h5>',
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.novoParticipante()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "small"
    }
  }, [_vm._v(" Novo Participante")])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "title": '<h5>Busca Participantes de Relatórios Anteriores</h5>',
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.buscarParticipantes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "small"
    }
  }, [_vm._v(" Buscar(GETEC)")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'top', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Exportar o conteúdo da listagem para Excel</h5>'
    }
  }, [_c('download-excel', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "data": _vm.json_data,
      "meta": _vm.json_meta,
      "type": "xls",
      "fields": _vm.json_fields,
      "name": _vm.nomeExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Exportar para Excel\n              ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "box-title control-label",
    staticStyle: {
      "font-size": "medium"
    }
  }, [_vm._v(_vm._s(_vm.table.items.length) + " " + _vm._s(_vm.table.items.length > 1 ? 'participantes cadastrados' : 'participante cadastrado') + "\n            "), (_vm.$route.params.row.item.sequencia > 1) ? _c('span', {
    staticClass: "text-muted"
  }, [(_vm.propsRelatorio.tipo_relatorio === 'FINAL') ? _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle icone_ajuda",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>O sistema mostra todos os participantes cadastrados anteriormente, excluindo duplicidade de CPF e nome.<br/>A instituição poderá alterar ou excluir participantes neste Relatório Final.</h5>'
    }
  }) : _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle icone_ajuda",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>O sistema mostra todos os participantes cadastrados anteriormente, excluindo duplicidade de CPF e nome.<br/>A instituição poderá alterar ou excluir participantes somente no Relatório Final.</h5>'
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "tabelaUsuarios",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "data_nascimento",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.disable || (_vm._.has(row.item, 'editavel') && row.item.editavel === 0 && _vm.propsRelatorio.tipo_relatorio === 'PARCIAL')) ? _c('span', [_c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.visualiza(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar")])], 1) : _c('span', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "error",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.exclui(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome do Participante')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "nomeParticipante"
    }
  }, [_vm._v("Nome Completo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participantes.nome),
      expression: "participantes.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nomeParticipante",
      "name": "Nome do Participante",
      "type": "text",
      "maxlength": "255",
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
    },
    domProps: {
      "value": (_vm.participantes.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participantes, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Nome do Participante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome do Participante')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.calculaIdade < 18) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "cpfParticipante"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf'),
      expression: "'cpf'"
    }],
    ref: "cpfParticipante",
    staticClass: "form-control",
    attrs: {
      "id": "cpfParticipante",
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
      "name": "CPF do Participante",
      "type": "text",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.participantes.cpf),
      callback: function($$v) {
        _vm.$set(_vm.participantes, "cpf", $$v)
      },
      expression: "participantes.cpf"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CPF do Participante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF do Participante')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.calculaIdade > 18) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CPF do Participante')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "cpfParticipante"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    ref: "cpfParticipante",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
      "name": "CPF do Participante",
      "type": "text",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.participantes.cpf),
      callback: function($$v) {
        _vm.$set(_vm.participantes, "cpf", $$v)
      },
      expression: "participantes.cpf"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CPF do Participante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF do Participante')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Data de nascimento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "Data de nascimento"
    }
  }, [_vm._v("\n              Data de nascimento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dt_nascimento_participante),
      expression: "dt_nascimento_participante"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast'),
      expression: "'required|validdate|dateeqpast'"
    }],
    ref: "Data de nascimento",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Data de nascimento",
      "name": "Data de nascimento",
      "data-vv-as": "Data de nascimento",
      "masked": _vm.masked,
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
    },
    domProps: {
      "value": (_vm.dt_nascimento_participante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dt_nascimento_participante = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Data de nascimento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data de nascimento')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "box-body"
  }, [(_vm.dt_nascimento_participante) ? _c('span', [_vm._v(" Idade: "), _c('b', [_vm._v(_vm._s(_vm.calculaIdade))]), _vm._v(" anos")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "foneParticipante"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('the-mask', {
    ref: "foneParticipante",
    staticClass: "form-control",
    attrs: {
      "id": "foneParticipante",
      "name": "Telefone do Participante",
      "type": "text",
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
      "masked": false,
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.participantes.telefone),
      callback: function($$v) {
        _vm.$set(_vm.participantes, "telefone", $$v)
      },
      expression: "participantes.telefone"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Sexo do Participante')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "sexoParticipante"
    }
  }, [_vm._v("Gênero:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participantes.sexo),
      expression: "participantes.sexo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "sexoParticipante",
    staticClass: "form-control",
    attrs: {
      "id": "sexoParticipante",
      "name": "Sexo do Participante",
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participantes, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Masculino"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Feminino"
    }
  }, [_vm._v("Feminino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Não Binário"
    }
  }, [_vm._v("Não Binário")])])]), _vm._v(" "), (_vm.errors.first('Sexo do Participante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Sexo do Participante')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Escolaridade do Participante')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "escParticipante"
    }
  }, [_vm._v("Escolaridade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participantes.escolaridade),
      expression: "participantes.escolaridade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "escParticipante",
    staticClass: "form-control",
    attrs: {
      "id": "escParticipante",
      "name": "Escolaridade do Participante",
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participantes, "escolaridade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Analfabeto"
    }
  }, [_vm._v("Analfabeto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ensino Fundamental"
    }
  }, [_vm._v("Ensino Fundamental")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ensino Médio"
    }
  }, [_vm._v("Ensino Médio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Superior Incompleto"
    }
  }, [_vm._v("Superior Incompleto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Superior Completo"
    }
  }, [_vm._v("Superior Completo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pós-graduação"
    }
  }, [_vm._v("Pós-graduação")])])]), _vm._v(" "), (_vm.errors.first('Escolaridade do Participante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Escolaridade do Participante')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('ufParticipante')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "ufParticipante"
    }
  }, [_vm._v("UF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participantes.UF),
      expression: "participantes.UF"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ufParticipante",
      "id": "ufParticipante",
      "disabled": _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0)
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participantes, "UF", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.carregaMunicipios(_vm.participantes.UF)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.participantes.UF,
      "selected": _vm.participantes.UF
    }
  }, [_vm._v(_vm._s(_vm.participantes.UF))]), _vm._v(" "), _vm._l((_vm.estados), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf))])
  })], 2)]), _vm._v(" "), (_vm.errors.first('ufParticipante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo UF do participante é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('munParticipante')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "munParticipante"
    }
  }, [_vm._v("Municipio:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.municipios,
      "id": "munParticipante",
      "multiple": false,
      "disabled": !_vm.participantes.UF || _vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0),
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um Município",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaListaMunicipios,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "munParticipante"
    },
    model: {
      value: (_vm.participantes.municipio),
      callback: function($$v) {
        _vm.$set(_vm.participantes, "municipio", $$v)
      },
      expression: "participantes.municipio"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('munParticipante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Município do participante é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "descricao-publico-alvo-container"
  }, [_c('publicoAlvoDescricao', {
    ref: "publicoAlvoDescricao",
    attrs: {
      "proposta": _vm.propsRelatorio.id_proposta,
      "idParticipante": _vm.idParticipante,
      "fixado": true,
      "permiteEditar": _vm.permiteEditarDescricao,
      "abrirAbas": true,
      "telaParticipante": true,
      "tipoDescricao": "REALIZADO",
      "dataNascimentoEdit": _vm.dt_nascimento_participante,
      "sexoEdit": _vm.participantes.sexo,
      "escolaridadeEdit": _vm.participantes.escolaridade
    },
    on: {
      "descricaoParticipanteDefs": function($event) {
        _vm.descricaoParticipante = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row container-botoes"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(!(_vm.disable || (_vm._.has(_vm.participantes, 'editavel') && _vm.participantes.editavel === 0))) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-team-add"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-team-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n              ")])])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbb9ce9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/listaParticipantes.vue
// module id = 2073
// module chunks = 1